import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-a8dc1924',
  styleUrl: './md-a8dc1924.css',
  templateUrl: './md-a8dc1924.html',
})
export class MdA8dc1924 { readonly config = ENTITY_CONFIGS['a8dc1924']; }
